import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { nftDevelopmentPageSeo } from './NftDevelopmentPage.seo';
import type { NftDevelopmentPageProps } from './NftDevelopmentPage.types';
import { NftServices } from './NftServices';
import { Testimonial } from './Testimonial';

export const NftDevelopmentPage = ({ blogPosts }: NftDevelopmentPageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...nftDevelopmentPageSeo} />

      <Hero />
      <NftServices />
      <Testimonial />
      <Benefits />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to Nft Development!"
        color="green"
      />
    </Layout>
  );
};
